import { render, staticRenderFns } from "./SnowDataTable.vue?vue&type=template&id=314cff78&scoped=true&"
import script from "./SnowDataTable.vue?vue&type=script&lang=js&"
export * from "./SnowDataTable.vue?vue&type=script&lang=js&"
import style0 from "./SnowDataTable.vue?vue&type=style&index=0&id=314cff78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314cff78",
  null
  
)

export default component.exports